import { AxiosResponse } from 'axios';
import { baseApi } from 'api/base';
import { BackendFileType } from './params';

const getFileName = (rawFilename: string): string => {
  const regFileName = rawFilename.includes('filename*=UTF-8')
    ? /filename\*=UTF-8''?([^"]+)"?/
    : /filename="?([^"]+)"?/;
  const filename = rawFilename.match(regFileName);
  return filename ? decodeURIComponent(filename[1]) : '';
};

const downloadFile = async (response: AxiosResponse): Promise<void> => {
  const rawFilename = response.headers['content-disposition'];
  const filename = rawFilename ? getFileName(rawFilename) : '';
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename || '');
  link.click();
  window.URL.revokeObjectURL(url);
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  }
};

const uploadFile = async (file: File, type: BackendFileType) => {
  const formData = new FormData();
  formData.append('multipartFile', file);
  const res = await baseApi.post('/files/upload', formData, {
    params: {
      fileType: type,
    },
  });
  return res.data;
};

const getFile = async (id: string) => {
  const res = await baseApi.get(`/files/${id}`, { responseType: 'blob' });
  return res.data;
};

export const fileApi = {
  downloadFile,
  uploadFile,
  getFile,
};
